"use client";

import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { X } from "lucide-react";

import { cn } from "../../lib/utils";

const closeVariants = cva(
  "rounded-sm opacity-70 transition-opacity hover:opacity-100 hover:cursor-pointer focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none",
  {
    variants: {
      variant: {
        default: "",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

interface CloseProps
  extends
    React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof closeVariants> {}

function Close({
  title = "Close",
  className,
  variant,
  ...props
}: Readonly<CloseProps>) {
  return (
    <div
      className={cn(closeVariants({ variant, className }))}
      title={title}
      {...props}
    >
      <X className="h-4 w-4" />
      <span className="sr-only">{title}</span>
    </div>
  );
}

export { Close, closeVariants };
